import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex-shrink-0 mr-2"
}
const _hoisted_2 = { class: "h-7 w-7 sm:h-8 sm:w-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs" }
const _hoisted_3 = {
  key: 0,
  class: "text-xs font-medium mb-1 text-blue-300"
}
const _hoisted_4 = { class: "text-sm sm:text-base break-words" }
const _hoisted_5 = { class: "text-xs mt-1 opacity-70 flex justify-end items-center" }
const _hoisted_6 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_7 = {
  key: 0,
  class: "inline-block w-3 h-3 sm:w-4 sm:h-4",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_8 = {
  key: 1,
  class: "inline-block w-3 h-3 sm:w-4 sm:h-4",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["message-item flex", _ctx.isCurrentUser ? 'justify-end' : 'justify-start'])
  }, [
    (!_ctx.isCurrentUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.userInitial), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["max-w-[85%] sm:max-w-xs md:max-w-md rounded-lg p-2 sm:p-3", 
        _ctx.isCurrentUser
          ? 'bg-blue-600 text-white rounded-br-none'
          : 'bg-gray-700 text-white rounded-bl-none'
      ])
    }, [
      (!_ctx.isCurrentUser && _ctx.message.sender)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.message.sender.username), 1))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.message.content), 1),
      _createElementVNode("div", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.formatTime(_ctx.message.createdAt)) + " ", 1),
        (_ctx.isCurrentUser)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
              (_ctx.message.isRead)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _cache[0] || (_cache[0] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M5 13l4 4L19 7"
                    }, null, -1)
                  ])))
                : (_openBlock(), _createElementBlock("svg", _hoisted_8, _cache[1] || (_cache[1] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
                    }, null, -1)
                  ])))
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 2))
}